/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_Action_MessageInputs */

const en_students_action_message = /** @type {(inputs: Students_Action_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const he_students_action_message = /** @type {(inputs: Students_Action_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעה`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Students_Action_MessageInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_action_message = /** @type {((inputs?: Students_Action_MessageInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_Action_MessageInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_action_message(inputs)
	return he_students_action_message(inputs)
});